import { Injectable } from '@angular/core';
import { BaseResourceService } from './base/base-resource.service';
import {
  TemplateResourceData,
  TemplateText,
} from './models/template-resource-data';
import { ApplicationResourceType } from './models/application-resource';

export const TEMPLATES_KEYS = {
  'DECISION-ATTORNEYGENERAL': 'DECISION-ATTORNEYGENERAL',
  'DECISION-CANCEL': 'DECISION-CANCEL',
  DEFAULT: 'DEFAULT',
};

@Injectable({ providedIn: 'root' })
export class TemplatesService extends BaseResourceService<TemplateResourceData> {
  type: ApplicationResourceType = 'TEMPLATE';

  public getTextsForKey(templateKey: string): TemplateText[] {
    return this.getResources()
      .filter((template) => template.data.key === templateKey)
      .map((template) => template.data.texts)
      .reduce((_prev, curr, _index, _arr) => [...curr], []);
  }
}
